import { captureAdAttribution, trackMetaPageView } from "./src/utils/google-ads"

export const onClientEntry = () => {
  captureAdAttribution()
}

// onRouteUpdate fires on the initial load AND every client-side navigation, so
// it is the single source of Meta PageView events (the pixel base code in
// gatsby-ssr.tsx is init-only — firing PageView in both places would
// double-count the landing hit).
export const onRouteUpdate = () => {
  captureAdAttribution()
  trackMetaPageView()
}

export { wrapPageElement } from "./gatsby-shared/wrap-page-element"
